import React from 'react';
import PropTypes from 'prop-types';

import BookmarkIcon from '~/src/components/svg/action/Bookmark';
import ActivityButton from '~/src/components/activity/button/ActivityButton';

import {ButtonFormat, ColorScheme} from '~/src/utilities/constants/formats';
import {withContext} from '~/src/components/context/Context';
import {withTypeContext} from '~/src/components/context/TypeContext';
import {getBookmarks, addBookmark, removeBookmark} from '~/src/utilities/feed/bookmark.js';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './BookmarksButton.i18n';

const getTranslation = initPolyglot(i18nStrings);

class BookmarksButton extends React.Component {
    isBookmarked(bookmarks) {
        return bookmarks.some((bookmark) => bookmark.content.id === this.props.metadataId.toString());
    }

    handleClick = () => {
        if (!this.props.isDisabled) {
            const appearsBookmarked = this.isBookmarked(this.props.bookmarks);

            // get bookmarks with real backend status
            getBookmarks().then((bookmarks) => {
                if (bookmarks) {
                    const isBookmarked = this.isBookmarked(bookmarks);

                    if (appearsBookmarked && isBookmarked) {
                        removeBookmark(this.props.metadataId, this.props.context.type);
                    }

                    if (!appearsBookmarked && !isBookmarked) {
                        addBookmark(this.props.metadataId, this.props.context.type);
                    }
                }
            });
        }
    };

    render() {
        const isBookmarked = this.isBookmarked(this.props.bookmarks);
        const bookmarksCount = this.props.activityCount + (isBookmarked ? 1 : 0);

        return (
            <ActivityButton
                isDisabled={this.props.isDisabled}
                highlighted={isBookmarked}
                activityCount={bookmarksCount}
                format={this.props.format}
                colorScheme={this.props.colorScheme}
                action="bookmark"
                onClick={this.handleClick}
                data-testid="ButtonBookmark"
            >
                <BookmarkIcon selected={isBookmarked} title={getTranslation('title')} />
            </ActivityButton>
        );
    }
}

const BookmarksButtonLoader = ({format}) => {
    return (
        <ActivityButton isDisabled={false} highlighted={false} disabled={true} format={format} activityCount="-" data-testid="ButtonBookmark">
            <BookmarkIcon selected={false} />
        </ActivityButton>
    );
};

if (process.env.NODE_ENV === 'development') {
    BookmarksButton.propTypes = {
        activityCount: PropTypes.number,
        format: PropTypes.oneOf(Object.values(ButtonFormat)).isRequired,
        colorScheme: PropTypes.oneOf(Object.values(ColorScheme)),
        metadataId: PropTypes.string.isRequired,
        isDisabled: PropTypes.bool
    };
}

export {BookmarksButtonLoader};

export default withContext(withTypeContext(BookmarksButton));
